module.exports = __webpack_public_path__ + "img/soy-organizacion_banner_3.ea1e9493.webp";